import "./dashed-spacer.scss"

interface IDashedSpacerProps {
    topMargin: string;
    bottomMargin: string;
}

const DashedSpacer: React.FC<IDashedSpacerProps> = ({topMargin, bottomMargin}): JSX.Element => (
    <div style={{paddingTop: topMargin, marginBottom: bottomMargin}} className="dashed-spacer"/>
);

export default DashedSpacer;
